export default __webpack_public_path__ + "static/media/spring-svg.840a3a0a.png";